import { RouteConfig } from 'vue-router';
import ReportsDashboard from '@/modules/reports/dashboard/views/ReportsDashboard.vue';
import AvailabilityRegistry from '@/modules/reports/management/views/AvailabilityRegistry.vue';
import IncidentRegistry from '@/modules/reports/management/views/IncidentRegistry.vue';
import ReportsView from '@/modules/reports/management/views/ReportsView.vue';
import IncidentsView from '@/modules/reports/management/views/IncidentsView.vue';
import ReportRegistry from '@/modules/reports/management/views/ReportRegistry.vue';
import HealthReports from '@/modules/reports/health-reports/views/HealthReports.vue';
import UploadHealthReport from '@/modules/reports/health-reports/views/UploadHealthReport.vue';
import CustomerHealthReports from '@/modules/reports/health-reports/views/CustomerHealthReports.vue';
import MaintenanceReportsView from '@/modules/reports/maintenance-reports/views/MaintenanceReportsView.vue';

export const reportsRouter: RouteConfig[] = [
    {
        path: 'reports',
        name: 'reports',
        component: ReportsDashboard,
    },
    {
        path: 'availability-registry',
        name: 'availability-registry',
        component: AvailabilityRegistry,
    },
    {
        path: 'incident-registry',
        name: 'incident-registry',
        component: IncidentRegistry,
    },
    {
        path: 'dayco-reports-history',
        name: 'dayco-reports-history',
        component: ReportsView,
    },
    {
        path: 'dayco-incidents-history',
        name: 'dayco-incidents-history',
        component: IncidentsView,
    },
    {
        path: 'dayco-report-registry',
        name: 'dayco-report-registry',
        component: ReportRegistry,
    },
    {
        path: 'dayco-health-report-registry',
        name: 'dayco-health-report-registry',
        component: UploadHealthReport,
    },
    {
        path: 'informs',
        name: 'informs',
        component: MaintenanceReportsView,
    },
    {
        path: 'health-informs',
        name: 'health-informs',
        component: HealthReports,
    },
    {
        path: 'customer-health-informs',
        name: 'customer-health-informs',
        component: CustomerHealthReports,
    },
];
